import { API_ENDPOINT } from '../constants.js';
import asyncValidate from '../validations/asyncValidate';

export const calculatePrice = data => ({
	type: 'CALCULATE_PRICE',
	payload: data.message
});

export const currencyChange = data => ({
	type: 'CHANGE_CURRENCY',
	payload: data
});

export const addFiles = data => ({
	type: 'ADD_FILES',
	payload: data
});

export const addFilesToForm = data => ({
	type: 'ADD_FILE_TO_FORM',
	payload: data
});

export const updateExistingFile = data => ({
	type: 'UPDATE_FILE',
	payload: data
})

export const updateFileWordCount = data => ({
	type: 'UPDATE_WORDCOUNT',
	payload: data
})

export const updateFilePageCount = data => ({
	type:'UPDATE_PAGECOUNT',
	payload: data
})

export const priceRefreshStart = () => ({
	type: 'PRICE_REFRESH_START'
})

export const priceRefreshEnd = () => ({
	type: 'PRICE_REFRESH_END'
})

export const updateGlobalCount = data => ({
	type: 'UPDATE_GLOBAL_COUNT',
	payload: data
})

export const removeFiles = file => ({
	type: 'REMOVE_FILES',
	payload: file
})

export const removeFilesFromForm = file => ({
	type: 'REMOVE_FILE_FROM_FORM',
	payload: file
})

export const shippingAddressFilled = data => ({
	type: 'SHIPPING_ADDRESS_FILLED',
	payload: data
})

export const samedAddressSelection = () => ({
	type: 'SAME_ADDRESS_CHANGE'
})

export const updateFilePages = data => ({
	type: 'UPDATE_PAGES',
	payload: data
})

export const changeLanguage = value => ({
	type: 'SET_LANG',
	payload: value
})

export const deleteDoc = value => ({
	type: 'DELETE_DOC',
	payload: value
})

export const syncContact = data => ({
	type: 'SYNC_CONTACT_INFO',
	payload: data
})

export function serviceRequestSelection(data) {
	return (dispatch, getState) => {
		const service = data.target.value;
		calculateTotalCount(dispatch, getState, service);
	}
}

export function updateWordCount(data) {
	return (dispatch, getState) => {
		const service = getState().form.davron.values.service;
		let handle = null;
		let words = 0;
		let pages = 0;

		if (service === "official") {
			handle = (data.target.name).substring(
				(data.target.name).lastIndexOf("fileSection.") + 12, 
				(data.target.name).lastIndexOf(".pages")
			);
			words = getState().form.davron.values.fileSection[handle].words
			pages = parseInt(data.target.value, 10)
			dispatch(updateFilePages({"handle": handle, "pages": pages, "words": words}))
		} else {
			handle = (data.target.name).substring(
				(data.target.name).lastIndexOf("fileSection.") + 12, 
				(data.target.name).lastIndexOf(".words")
			);
			words = parseInt(data.target.value, 10)
			pages = Math.ceil(words/250); //getState().form.davron.values.fileSection[handle].pages
			dispatch(updateFilePages({"handle": handle, "pages": pages, "words": words}))
		}

		const uploadedFiles = getState().form.davron.values.fileSection;
		let totalCount = 0;
		let getPrice = 0;
		if (uploadedFiles) {
			if (service==='official') {
				for (const [key, values] of Object.entries(uploadedFiles)) {
					if (key === handle) {
						totalCount += parseInt(pages, 10)
					} else {
						totalCount += parseInt(uploadedFiles[key]["pages"], 10)
					}
					if ("document" in values) { 
						getPrice = 1;
					}
				}
			} else {
				for (const key of Object.keys(uploadedFiles)) {
					if (key === handle) {
						totalCount += parseInt(words, 10)
					} else {
						totalCount += parseInt(uploadedFiles[key]["words"], 10)
					}
				}
			}
			dispatch(updateGlobalCount(totalCount))
	
			if ((service==='official' && getPrice === 1) || (service!=='official')) {
				asyncValidate(getState().form.davron.values, dispatch)
			}
		}
	}
}

export function newFileUpload(file, blob) {
	return (dispatch, getState) => {
		return countWords(blob).then(result => {
			file.words = result;
			file.pages = Math.ceil(result/250);
			dispatch(addFiles(file));
			dispatch(addFilesToForm(file))
			const service = getState().form.davron.values.service;
			calculateTotalCount(dispatch, getState, service)
			return result
		})
		.then(() => {
			if (getState().form.davron.values.service !== "official") {
				asyncValidate(getState().form.davron.values, dispatch)
			}
		}).catch(() => {
			file.words = 0;
			file.pages = 0;
			dispatch(addFiles(file));
			dispatch(addFilesToForm(file))
			asyncValidate(getState().form.davron.values, dispatch)
		})
	}
}

function calculateTotalCount(dispatch, getState, service) {
	const uploadedFiles = getState().form.davron.values.fileSection;
	let values = getState().form.davron.values;
	values.service = service;
	let totalCount = 0;
	let getPrice = 0;
	if (uploadedFiles) {
		if (service==='official') {
			for (const [key, values] of Object.entries(uploadedFiles)) {
				totalCount += parseInt(uploadedFiles[key]["pages"], 10)
				if ("document" in values) { 
					getPrice = 1;
				}
			}
		} else {
			for (const key of Object.keys(uploadedFiles)) {
				totalCount += parseInt(uploadedFiles[key]["words"], 10)
			}
		}
		dispatch(updateGlobalCount(totalCount))

		if ((service==='official' && getPrice === 1) || (service!=='official')) {
			asyncValidate(values, dispatch)
		}
	}
}

export function fileDeletion(file) {
	return (dispatch, getState) => {
		dispatch(removeFilesFromForm(file));
		dispatch(removeFiles(file));
		let uploadedFiles = getState().globals.files;
		let totalCount = 0;
		uploadedFiles.forEach(uploadfile => {
			totalCount += parseInt(uploadfile.words, 10)
		})
		dispatch(updateGlobalCount(totalCount))
	}
}

async function countWords(blob) {
	return new Promise((resolve, reject) => {
		let r = new FileReader();
		r.onload = function(e) {
			let contents = e.target.result;
			let res = contents.split(/\s+/);
			resolve(res.length);
		}
		r.readAsText(blob);
	})
}

export function requestPrice() {
	return (dispatch, getState) => {
		dispatch(priceRefreshStart())
		const data = {
			values: getState().form.davron.values,
			currency: getState().form.davron.values.currency,
			lang: getState().globals.lang,
			price: getState().globals.price
		};

		return fetch(`${API_ENDPOINT}/api/method/davrontranslations.davrontranslations.api.get_item_price`, {
			method: "POST",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			redirect: "follow",
			referrer: "no-referrer",
			body: JSON.stringify({data: data}),
		})
		.then(response => response.json())
		.then(result => {
			dispatch(calculatePrice(result))
			dispatch(priceRefreshEnd())
		})
		.catch(() => {});
	}
}

export function getLinkedContact(user) {
	return (dispatch, getState) => {
		return fetch(`${API_ENDPOINT}/api/method/davrontranslations.davrontranslations.api.get_user_details`, {
			method: 'POST',
			credentials: 'include',
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({data: {user: user}})
		}).then(response => {
			return response.json()
		}).then(result => {
			result&&result.message&&dispatch(syncContact(result.message))
		}).catch(() => {});
	}
}

export function getLinkedAddresses(user) {
	return (dispatch, getState) => {
		const formData = new FormData()
		formData.append('user', user)
		return fetch(`${API_ENDPOINT}/api/method/davrontranslations.davrontranslations.api.get_user_addresses`, {
			method: 'POST',
			credentials: 'include',
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({data: {user: user}})
		}).then(response => {
			return response.json()
		}).then(result => {
			result&&result.message&&dispatch(syncContact(result.message))
		}).catch(() => {});
	}
}


// WEBPACK FOOTER //
// ./src/actions/index.js